import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getRequest, postRequest } from "../../apiWrapper";

const AdminDashboard = () => {
  const [teachers, setTeachers] = useState([]);
  const [approvedTeachers, setApprovedTeachers] = useState([]);

  // API から教師データを取得し、承認待ち・承認済みのリストに分ける
  const fetchTeachers = async () => {
    try {
      const data = await getRequest("teachers?excludeRetired=true");
      if (data && data.teachers) {
        const teacherList = data.teachers;
        // 承認済み・未承認のリストを分ける
        setTeachers(teacherList.filter((teacher) => !teacher.approved));
        setApprovedTeachers(teacherList.filter((teacher) => teacher.approved));
      }
    } catch (error) {
      console.error("❌ 教師データ取得エラー:", error);
    }
  };

  useEffect(() => {
    fetchTeachers();
    // 必要に応じてポーリングなどで定期的に更新する処理を追加してください
  }, []);

  // 承認処理（`approved: true` に更新）
  const approveTeacher = async (teacherid) => {
    try {
      const response = await postRequest("teachers/approve", {
        uid: teacherid,
      });
      const result = await response.json();
      if (response.ok) {
        fetchTeachers();
      } else {
        console.error("❌ 承認エラー:", result);
      }
    } catch (error) {
      console.error("❌ 承認エラー:", error);
    }
  };

  // 未承認状態に戻す（`approved: false` に変更）
  const revokeApproval = async (teacherid) => {
    try {
      const response = await postRequest("teachers/revoke", {
        uid: teacherid,
      });
      const result = await response.json();
      if (response.ok) {
        fetchTeachers();
      } else {
        console.error("❌ 承認取り消しエラー:", result);
      }
    } catch (error) {
      console.error("❌ 承認取り消しエラー:", error);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* 🔹 メインコンテンツ */}
      <div className="flex-1 p-3 pt-20 overflow-auto">
        {/* 承認待ちの講師リスト */}
        <div className="mb-6 bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-4">承認待ちの講師</h2>
          {teachers.length === 0 ? (
            <p className="text-gray-500">現在、承認待ちの講師はいません。</p>
          ) : (
            <ul>
              {teachers.map((teacher) => (
                <li
                  key={teacher.id}
                  className="flex justify-between items-center py-3 border-b last:border-none"
                >
                  <span className="text-lg">{teacher.name}（{teacher.teacherid}）</span>
                  <button
                    onClick={() => approveTeacher(teacher.id)}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
                  >
                    承認
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* 承認済みの講師リスト */}
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold mb-4">承認済みの講師</h2>
          {approvedTeachers.length === 0 ? (
            <p className="text-gray-500">現在、承認済みの講師はいません。</p>
          ) : (
            <ul>
              {approvedTeachers.map((teacher) => (
                <li
                  key={teacher.id}
                  className="flex justify-between items-center py-3 border-b last:border-none"
                >
                  <span className="text-lg">{teacher.name}（{teacher.teacherid}）</span>
                  <button
                    onClick={() => revokeApproval(teacher.id)}
                    className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition"
                  >
                    承認を取り消し
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
